































import Vue from "vue";
import { Location } from "vue-router";
import { convertToDeeplink } from "@tt-app/utils";

import TtBreadCrumbNav from "@tt-app/components/layout/TtBreadCrumbNav.vue";

interface Computed {
  deepLink: string;
  displayBackIcon: boolean;
  displayBreadcrumbs: boolean;
}

interface Props {
  backIcon?: string;
  backFallback?: Location;
  // Optional navigation breadcrumbs
  breadcrumbs?: string[];
  // General flag to hide/show the header
  displayHeader: boolean;
  // If loading, don't display the card
  loading: boolean;
  // If true, the layout will not handle any overflow scrolling on desktop view.
  // On mobile view, as the whole layout is scrolled over, the behaviour does
  // not depend on the content
  noDesktopScroll: boolean;
}

/**
 * Opinionated layout with:
 *  as Header:
 *  - a TtBackBtn
 *  - a Breadcrumb navigation
 *  as Body:
 *  - a container which touches the bottom with an "overflow-y: auto"
 */
export default Vue.extend<{}, {}, Computed, Props>({
  name: "LayoutFullCard",
  components: { TtBreadCrumbNav },

  props: {
    backIcon: { type: String, default: undefined },
    backFallback: { type: Object, default: undefined },
    breadcrumbs: { type: Array as () => string[], default: undefined },
    displayHeader: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    noDesktopScroll: { type: Boolean, default: false }
  },

  computed: {
    deepLink() {
      return convertToDeeplink(window.location.href);
    },
    displayBackIcon() {
      return this.displayHeader;
    },
    displayBreadcrumbs() {
      return this.displayHeader && this.breadcrumbs !== undefined;
    }
  }
});
